import { printLine, parseStyledString } from "../utilities.js";
import { state } from "../state.js";
import { screen } from "../screen.js";

export const program = {
    name: "about",
    size: 44, // Number of lines of this 'program'
    list: async () => {
        await printLine("32 SYS 4096"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async () => {
        state.blockCursor = false;
        const refDate = new Date("2011-03-01");
        const today = new Date();
        let yearsWork = today.getFullYear() - refDate.getFullYear();
        if (today.getMonth() < refDate.getMonth() || (today.getMonth() === refDate.getMonth() && today.getDate() < refDate.getDate())) {
            yearsWork--;
        }
        await screen.clearScreen();
        await printLine(parseStyledString("HI, I'M [fg=yellow]DENNIS SMIT[/], A PROUD DAD,"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("[fg=yellow]BOARD[/] AND [fg=yellow]VIDEO[/] GAME ENTHUSIAST, AND"), { charDelay: 50, lineDelay: 50 });
        await printLine("AN ALLROUND GEEK WITH A PASSION FOR", { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("[fg=yellow]INNOVATION[/]."), { charDelay: 50, lineDelay: 1000 });
        await printLine();
        await printLine("EVER SINCE I GOT MY FIRST COMPUTER, A", { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("[fg=white]COMMODORE 64[/], AT THE AGE OF [fg=white]10[/], I AM"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("EXPLORING THE WORLD OF PROGRAMMING."), { charDelay: 50, lineDelay: 1000 });
        await printLine();
        await printLine(parseStyledString("[bg=default_fg,fg=default_bg]THIS SITE IS A HOMAGE TO THAT ICONIC PC![/]"), { charDelay: 50, lineDelay: 1000 });
        await printLine(parseStyledString("BASED IN UTRECHT, THE [fg=orange]NETHERLANDS[/], I'VE"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("SPENT OVER [fg=orange]" + yearsWork + "[/] YEARS CREATING ALL KINDS"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("OF [fg=orange]EXCITING[/] DIGITAL SOLUTIONS."), { charDelay: 50, lineDelay: 1000 });
        await printLine();
        await printLine(parseStyledString("EARLY [fg=cyan]2025[/] I'VE CO-FOUNDED [fg=cyan]SHOOT THE[/]"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("[fg=cyan]PENGUIN STUDIOS[/], A GAME DEVELOPMENT"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("STUDIO SPECIALIZING IN [fg=cyan]UNITY[/]."), { charDelay: 50, lineDelay: 1000 });
        await printLine("WE ARE CURRENTLY WORKING ON OUR FIRST", { charDelay: 50, lineDelay: 50 });
        await printLine("GAME AND ARE EXCITED TO SHARE MORE", { charDelay: 50, lineDelay: 50 });
        await printLine("ABOUT IT SOON, SO STAY TUNED!", { charDelay: 50, lineDelay: 1000 });
        await printLine();
        await printLine(parseStyledString("GET IN TOUCH IF YOU LIKE TO HAVE A [fg=purple]CHAT[/]"), { charDelay: 50, lineDelay: 50 });
        await printLine(parseStyledString("OR JUST WANT TO SAY [fg=purple]HELLO[/]!"), { charDelay: 50, lineDelay: 5000 });
    }
};